// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"style__wrapper___3ikFw"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/editRecipe/style.scss
 ** module id = 360
 ** module chunks = 0
 **/